import React from "react";
import {
  JoinHeaderBanner,
  BalloonCard,
  JoinBanner,
  MotivationPoints,
  Icon,
  Icons,
  ImageBlurb,
  ReviewsSlider,
  EmbedVideoCard,
  SquareCard,
  bem
} from "@obby/components";
import { JoinHeader } from "../components/JoinHeader";

import { styles } from "./TeacherJoinPage.styles";

const cn = bem("teacher-join-page");

export function TeacherJoinPage(props) {
  const { onClickGetStarted, onClickViewClass } = props;
  return (
    <div className={`${cn()} ${styles.teacherJoinPage}`}>
      <JoinHeader />
      <div className={`${cn("section")} pb-smd-3 ${styles.section}`}>
        <div className="container-fluid">
          <div className={`${cn("header")} ${styles.header}`}>
            <Icon
              className={`${cn("header-balloon")} ${styles.headerBalloon}`}
              icon={Icons.CommentRight}
            />
            <JoinHeaderBanner
              title="Earn money teaching with Obby"
              description={
                <>
                  <p>
                    Obby is a powerfully simple teaching platform, giving you
                    all the tools you need to launch and grow your teaching
                    business.
                  </p>
                  <p>
                    Whether you're a new teacher or an experienced one, we can
                    help you grow and develop a thriving teaching business.
                  </p>
                </>
              }
              cta="Start today"
              onCtaClick={onClickGetStarted}
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1596118915/Mask_Group_glmuhf.png"
              imageSticker="Teach new skills"
            />
          </div>
        </div>
      </div>
      <div
        className={`${cn("section")} py-4 ${styles.section({
          backgroundcolor: "white"
        })}`}
      >
        <div className="container-fluid">
          <h1
            className={`${cn("section-title")} my-smd-4 pt-lg-4 pb-lg-3 ${
              styles.sectionTitle
            }`}
          >
            Why teach with obby
          </h1>
          <div className="row">
            <div className="col-12 col-smd-4 my-4">
              <BalloonCard
                title="Teach online, in-person or both"
                description="Want to teach online or in person classes or even both? Obby has the features to get you running."
                image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1596190329/first_ballon_kc8jwd.png"
              />
            </div>
            <div className="col-12 col-smd-4 my-4">
              <BalloonCard
                title="Sell products & online courses too"
                description="Our tools make it easy for you to sell products such as craft / learning kits as well as enroll students to pre-recorded online courses too!"
                image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1596191943/second_ballon_edsnny.png"
              />
            </div>
            <div className="col-12 col-smd-4 my-4">
              <BalloonCard
                title="build a business"
                description="Obby will help you every step of the way making sure your business is successful."
                image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1596191951/third_ballon_vtu2ij.png"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`${cn("section")} py-4 my-4 ${styles.section}`}>
        <div className="container-fluid">
          <EmbedVideoCard
            title="Getting up and running is quick and easy"
            description="Follow our automatic signup process to create your account and submit your first class. Integrate your booking widget with your website. Market your classes (with the help of Obby too) and sit back whilst our automated payment system does everything else."
            embedHtml="<iframe src='https://player.vimeo.com/video/583749514' width='640' height='480' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen></iframe>"
          />
        </div>
      </div>
      <div className={`${cn("section")} my-4 py-4 ${styles.section}`}>
        <div className="container-fluid">
          <ReviewsSlider
            reviews={[
              {
                review:
                  "Obby has been pretty life changing for me! It has allowed me to work to my own schedule providing me with much needed flexibility. The team is always really helpful and you can tell that they all genuinely care and want to ensure everyone, students and teachers, have a good experience.",
                reviewer: "Aimee",
                target: "Aimee McCulloch Stained Glass"
              },

              {
                review:
                  "Obby’s help and support has reignited my confidence and passion for growing my business when I had previously felt alone. I have been learning a lot through all the support they provide that I can use in the future to help my business grow more efficiently.",
                reviewer: "Kim",
                target: "Thrifty Creations"
              },
              {
                review:
                  "Obby has made life easier, by eliminating time consuming parts of setting up and running workshops. We feel so supported by the team and make good use of their additional support features such as virtual assistants. We are more organised and professional as a result!",
                reviewer: "Darren",
                target: "Botanical Boys"
              },
              {
                review:
                  "Obby has completely changed the way of running short courses online. We switched from PayPal on our own site to Obby, which makes it easier for us to list information and handle bookings in one system. The support from Obby has been phenomenal and the booking process and communication with customers is all streamlined and requires much less admin.",
                reviewer: "Silvie",
                target: "London School of Mosaic"
              }
            ]}
          />
        </div>
      </div>

      <div className={`${cn("section")} py-4 ${styles.section}`}>
        <div className="container-fluid">
          <h1
            className={`${cn("section-title")} mt-3 mt-smd-4 mb-2 ${
              styles.sectionTitle
            }`}
          >
            How it works
          </h1>
          <div
            className={`${cn("section-description")} pb-lg-3 ${
              styles.sectionDescription
            }`}
          >
            Getting started is easy we show you the process of setting up below.
          </div>
          <div className="mb-4 pb-smd-3 position-relative">
            <Icon
              className={`${cn(
                "how-it-works-balloon"
              )} ${styles.howItWorksBalloon({ variant: "first" })}`}
              icon={Icons.CommentRight}
            />
            <JoinBanner
              title="Set up and customise your classes"
              description="Setup your own teaching website in minutes, making it super simple for customers to book your classes online. Take online payments directly from your website and enroll customers right off the bat. "
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1623235562/Page%20Images/inperson_classpage_placeholder.png"
              imageAlign="right"
            />
          </div>
          <div className="mb-4 pb-3 position-relative">
            <Icon
              className={`${cn(
                "how-it-works-balloon"
              )} ${styles.howItWorksBalloon({ variant: "second" })}`}
              icon={Icons.CommentRight}
            />
            <JoinBanner
              title="Take secure online payments"
              description={[
                "Create custom classes, invoice private and group bookings, and automatically send receipts, reminders and follow-up emails - fully customised in your own branding and all in one teaching platform.",
                "Reschedule, cancel and refund students. Track their previous bookings and reviews, and talk directly to your students to ease any anxieties."
              ]}
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1623235659/Page%20Images/stripe_paymentpage_placeholder.png"
            />
            <img
              className={`${cn("obby-gift")} ${styles.obbyGift}`}
              src="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1623238360/Page%20Images/obby-gift.png"
            />
          </div>
          <div className="mb-4 pb-smd-3 position-relative">
            <Icon
              className={`${cn(
                "how-it-works-balloon"
              )} ${styles.howItWorksBalloon({ variant: "third" })}`}
              icon={Icons.CommentRight}
            />
            <JoinBanner
              title="Create an amazing learning experience"
              description={[
                "Offer an immersive learning experience, chat with your students and send them content before the class starts.",

                "Use our class booking and calendar management tools to stay on-top of your schedule and easily move customers around between classes."
              ]}
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1623238838/Page%20Images/classroompage_placeholder.png"
              imageAlign="right"
            />
          </div>
          <div className="mb-4 pb-3 position-relative">
            <Icon
              className={`${cn(
                "how-it-works-balloon"
              )} ${styles.howItWorksBalloon({ variant: "second" })}`}
              icon={Icons.CommentRight}
            />
            <JoinBanner
              title="Create a fully branded website for your teaching business"
              description={[
                "Setup your own teaching website in minutes, making it super simple for customers to book your classes online. Take online payments directly from your website and enroll customers right off the bat.",
                "No need to deal with cash payments and customer no-shows. With Obby’s registration widget, you can take payments any time of the day and show your customers real-time availability all from your own website."
              ]}
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1596200856/midweek-vinyasa-flow_j7idvc.png"
            />
          </div>
          <div className="mb-4 pb-smd-3 position-relative">
            <Icon
              className={`${cn(
                "how-it-works-balloon"
              )} ${styles.howItWorksBalloon({ variant: "first" })}`}
              icon={Icons.CommentRight}
            />
            <JoinBanner
              title="Reach thousands of students via the obby marketplace"
              description="If you use the Obby teaching platform, you also get access to the Obby Marketplace, where we have helped over 50,000 students find the perfect class or teacher for them. Your class schedule and availability is automatically synced with our marketplace, so there is no additional work for you. You can just sit back, relax, and wait for new customers to come to you."
              image="https://res.cloudinary.com/obby/image/upload/fl_lossy,q_auto,f_auto/v1624870842/Page%20Images/marketplace_homepage_placeholder2.png"
              imageAlign="right"
            />
          </div>
        </div>
      </div>

      <div className={`${cn("section")} py-4 ${styles.section}`}>
        <div className="container-fluid">
          <h1
            className={`${cn("section-title")} my-3 pb-3 my-smd-4 pt-lg-4 ${
              styles.sectionTitle
            }`}
          >
            Support when you need it
          </h1>
          <MotivationPoints
            points={[
              {
                header: "Growth academy and training",
                description:
                  "The business academy will give you the tools to help grow your business to the next level through our in-house training & development modules."
              },
              {
                header: "Dedicated help from our team",
                description:
                  "If you need help or advice with your classes our team is here to help you. We have instant chat available and regular check-in calls with you."
              },
              {
                header: "Connect with other teachers",
                description:
                  "It can be lonely running a small teaching business. We have a great community team to help you connect to others and learn from the best."
              }
            ]}
            cols={{
              sm: 6,
              md: 4
            }}
            accentColor="robbinsEggBlue"
          />
        </div>
      </div>
      <div className={`${cn("section")} py-4 mb-4 ${styles.section}`}>
        <div className="container-fluid">
          <ImageBlurb
            color="white"
            backgroundColor="royal-blue"
            title="Start teaching with obby today"
            description="Ready to start? We’d love to have to you onboard. Click the button to get started and start teaching."
            thumbnail="https://res.cloudinary.com/obby/image/upload/v1596464467/2020_03_11_Karen_Reddskin-12_1_ex3mme.png"
            thumbnailPosition="right"
            cta="Start teaching"
            onCtaClick={onClickGetStarted}
          />
        </div>
      </div>

      <div className={`${cn("section")} my-4 py-4 ${styles.section}`}>
        <div className="container-fluid">
          <h1
            className={`${cn("section-title")} mt-3 mt-smd-4 mb-2 ${
              styles.sectionTitle
            }`}
          >
            Check out obby blog
          </h1>

          <div
            className={`${cn("section-description")} pb-lg-3 ${
              styles.sectionDescription
            }`}
          >
            Check out posts on how we can help grow your business.
          </div>
          <div className="row mt-4">
            <div className="col-12 col-sm-4 mb-4 mb-sm-0 pb-4 pb-sm-0">
              <SquareCard
                url="/blog/best-class-booking-system"
                thumbnail="https://res.cloudinary.com/obby/image/upload/v1624878603/Page%20Images/photo-1511871893393-82e9c16b81e3.jpg"
                title="Top 10 Best Class Booking Systems - Best Course Booking System"
                // description="Join a virtual classroom and learn in real time"
              />
            </div>
            <div className="col-12 col-sm-4 mb-4 mb-sm-0 pb-4 pb-sm-0">
              <SquareCard
                url="/blog/best-teaching-platforms/"
                thumbnail="https://res.cloudinary.com/obby/image/upload/v1624878450/Page%20Images/photo-1527689368864-3a821dbccc34.jpg"
                title="Top 10 Best Teaching Platforms To Use in 2021"
                // description="Learn in studio with your teacher and get hands on"
              />
            </div>
            <div className="col-12 col-sm-4 mb-4 mb-sm-0 pb-4 pb-sm-0">
              <SquareCard
                url="/blog/how-to-sell-online-courses-from-your-own-website/"
                thumbnail="https://res.cloudinary.com/obby/image/upload/v1624878668/Page%20Images/element5-digital-OyCl7Y4y0Bk-unsplash-1.jpg"
                title="How To Sell Online Courses From Your Own Website"
                // description="Learn anytime, anywhere with Kits & Pre-recorded Courses"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
